import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ErrorPage } from './pages/ErrorPage';
import { Layout } from './Layout';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { routes } from './routes';
import { Toaster } from '@packages/ui';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

const router = createBrowserRouter([
  {
    element: <Layout />,
    errorElement: <ErrorPage />,
    path: ':lang?',
    children: routes,
  },
]);

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, staleTime: 60 * 1000 } },
});

export const App = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <Toaster />
        <RouterProvider router={router} />
      </QueryClientProvider>
    </I18nextProvider>
  );
};
